// @flow
import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import CloudDone from "@material-ui/icons/CloudDone";
import CloudOff from "@material-ui/icons/CloudOff";
import Autorenew from "@material-ui/icons/Autorenew";
import { PrimaryGreen, GreyText, GreyLightText } from "../../../global/uis/scss";

type UserStatusLabelPropsType = {
  userStatus: string
};

const UserStatusLabel = (props: UserStatusLabelPropsType): React$Element<*> => {
  const userStatus = props.userStatus;
  if (userStatus === undefined) {
    return (
      <Tooltip title="">
        <Autorenew style={{ color: GreyLightText }} />
      </Tooltip>
    );
  }
  else if (userStatus === "CONFIRMED") {
    return (
      <Tooltip title="Activated">
        <CloudDone style={{ color: PrimaryGreen }} />
      </Tooltip>
    );
  }
  else {
    return (
      <Tooltip title="Not Activated">
        <CloudOff style={{ color: GreyText }} />
      </Tooltip>
    );
  }
};

export default UserStatusLabel;
